import { api } from './apiRtk/api';
import elevatorIntegrationFloorMapping from './modules/my2nApi/elevatorIntegrationSlice';

const rootReducerToolkit = {
  [api.reducerPath]: api.reducer,
  elevatorIntegrationFloorMapping: elevatorIntegrationFloorMapping,
};

export default rootReducerToolkit;
